import { Suspense, lazy } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Benefits } from "@/components/site/Benefits";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Gallery } from "@/components/site/Gallery";
import { Services } from "@/components/site/Services";
import { Testimonials } from "@/components/site/Testimonials";
import { Team } from "@/components/site/Team";
import { Footer } from "@/components/site/Footer";

const DreamGarage = lazy(() => import("@/components/site/DreamGarage").then((m) => ({ default: m.DreamGarage })));

export default function Landing() {
  return (
    <div className="bg-paper">
      <Navbar />
      <Hero />
      <Ribbon />
      <Benefits />
      <HowItWorks />
      <Gallery />
      <Services />
      <Testimonials />
      <Team />
      <Suspense fallback={<div id="dream" className="min-h-[600px] bg-surface border-y border-ink/10" />}>
        <DreamGarage />
      </Suspense>
      <Footer />
    </div>
  );
}
